import { useState, useRef, useEffect } from "react";

const useCountdown = (seconds: number) => {
  const [remaining, setRemaining] = useState(0);
  const timerRef = useRef<NodeJS.Timeout>();

  const start = () => setRemaining(seconds);

  useEffect(() => {
    if (remaining === 0) return;

    timerRef.current = setInterval(() => {
      setRemaining(prev => {
        if (prev <= 1) {
          clearInterval(timerRef.current);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timerRef.current);
  }, [remaining]);

  return { remaining, start };
};

export default useCountdown;